<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信设置协议版本'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="DomainName" label="选择服务器通道">
        <Select v-model="DomainName" style="width: 220px;" @on-change="onChange">
          <Option v-for="item in DomainNameOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="protocolVersion" label="协议版本">
        <Select v-model="protocolVersion" style="width: 220px;" @on-change="onChange">
          <Option v-for="item in protocolVersionOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="sms" label="短信内容">
        <Input v-model="sms" readonly placeholder="短信内容" style="width: 300px;">
        </Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuphikprotocolversionsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        //域名选项
        DomainName:null,
        DomainNameOptions: [
          {name: '服务器通道1(JC)', value: 0},
          {name: '服务器通道2(运维)', value: 1},
          {name: '服务器通道3(货运)', value: 2},
          {name: '服务器通道4(两客一危)', value: 3},
          {name: '服务器通道5', value: 4},
          {name: '服务器通道6', value: 5},
        ],
        protocolVersion:null,
        protocolVersionOptions: [
          {name: '2011', value: 0},
          {name: '2019', value: 1},
        ],

        sms:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onChange(){
        this.sms = 'JT808Ver:'+ this.DomainName +',' + this.protocolVersion + ';A'
      },
      onOk() {
        if (this.DomainName == null || this.DomainName === '') {
          this.$Message.error('请选择服务器通道')
          return
        }
        if (this.protocolVersion == null || this.protocolVersion === '') {
          this.$Message.error('请填写端口')
          return
        }
          //                       通道                         x协议版本
          this.sendSMS('JT808Ver:'+ this.DomainName +',' + this.protocolVersion + ';A')

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
